import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const RispostaChiusa = ({
  closeModal,
  setCurrentTab,
  dettagliNodi,
  selectedNode,
  setDettagliNodi,
}) => {
  const nodoKey = `nodo-${selectedNode.id}`;
  const nodeData = dettagliNodi[nodoKey]?.widget || {};
  const [currentChoice, setCurrentChoice] = useState(null);
  let locale = new URL(window.location.href).searchParams.get('locale') || 'it';
  const defaultChoicesName =
    locale && locale !== 'it' ? `choices_${locale}` : 'choices';

  useEffect(() => {
    if (!dettagliNodi[nodoKey]) {
      setDettagliNodi((prev) => ({
        ...prev,
        [nodoKey]: {
          widget: {
            type: 'select',
            content: '',
            variable_name: null,
            [defaultChoicesName]: [],
          },
        },
      }));
    }
  }, [selectedNode, setDettagliNodi]);

  const updateNodeDetails = (field, value) => {
    setDettagliNodi((prev) => {
      const prevWidget = prev[nodoKey]?.widget || {};
      const updatedWidget = { ...prevWidget };

      // Aggiornare i dati direttamente nell'oggetto widget
      updatedWidget[field] = value;

      return {
        ...prev,
        [nodoKey]: {
          ...prev[nodoKey],
          widget: updatedWidget,
        },
      };
    });
  };

  const handleSaveChoice = () => {
    if (currentChoice?.label && currentChoice?.content) {
      setDettagliNodi((prev) => {
        const prevWidget = prev[nodoKey]?.widget || {};
        const updatedWidget = { ...prevWidget };

        // Aggiornare le scelte nel widget
        updatedWidget[defaultChoicesName] = updatedWidget[defaultChoicesName]
          ? currentChoice.id
            ? updatedWidget[defaultChoicesName].map((choice) =>
                choice.id === currentChoice.id
                  ? { ...choice, ...currentChoice }
                  : choice,
              )
            : [
                ...updatedWidget[defaultChoicesName],
                { ...currentChoice, id: new Date().getTime() },
              ]
          : [{ ...currentChoice, id: new Date().getTime() }];

        return {
          ...prev,
          [nodoKey]: {
            ...prev[nodoKey],
            widget: updatedWidget,
          },
        };
      });

      setCurrentChoice(null); // Reset dopo il salvataggio
    }
  };

  const filteredNodes = Object.keys(dettagliNodi)
    .map((nodeKey) => {
      const node = dettagliNodi[nodeKey];
      return { value: node.id, label: node.node_label };
    })
    .filter((node) => node.value !== undefined && node.label !== undefined);

  const nodes_options = filteredNodes.length > 0 ? filteredNodes : [];

  const handleRemoveChoice = (choiceToRemove) => {
    setDettagliNodi((prev) => {
      const prevWidget = prev[nodoKey]?.widget || {};
      const updatedWidget = { ...prevWidget };

      updatedWidget[defaultChoicesName] = updatedWidget[defaultChoicesName]
        ? updatedWidget[defaultChoicesName].filter(
            (choice) => choice.id !== choiceToRemove.id,
          )
        : [];

      return {
        ...prev,
        [nodoKey]: {
          ...prev[nodoKey],
          widget: updatedWidget,
        },
      };
    });

    setCurrentChoice(null);
  };

  const nodeVariables = dettagliNodi?.[nodoKey]?.node_variables || [];
  const variable_options = nodeVariables.map((variable) => ({
    value: variable.nome_variabile,
    label: variable.nome_variabile,
  }));

  return (
    <div className="row" style={{ height: '530px' }}>
      <div
        className="col-6 ps-3 d-flex flex-column h-100"
        style={{ borderLeft: '1px black solid' }}
      >
        <label>Visualizza come</label>
        <select
          className="form-select mt-2 mb-3"
          value={nodeData.type === 'button' ? '2' : '1'}
          onChange={(e) =>
            updateNodeDetails(
              'type',
              e.target.value === '1' ? 'select' : 'button',
            )
          }
        >
          <option value="1">Dropdown</option>
          <option value="2">Bottoni</option>
        </select>

        <label>Label</label>
        <input
          type="text"
          className="form-control mt-2"
          value={nodeData.content || ''}
          onChange={(e) => updateNodeDetails('content', e.target.value)}
        />

        <label className="mt-3 mb-2">Seleziona variabile</label>
        <Select
          options={variable_options}
          value={
            variable_options.find(
              (option) => option.value === nodeData.variable_name,
            ) || null
          }
          onChange={(option) =>
            updateNodeDetails('variable_name', option ? option.value : null)
          }
          placeholder="Cerca..."
          isSearchable
        />

        <label className="mt-2">Elenco scelte</label>
        <div className="overflow-choice-menu">
          {nodeData[defaultChoicesName]?.length ? (
            nodeData[defaultChoicesName].map((choice) => (
              <div
                key={choice.id}
                className="scelta-widget"
                onClick={() => setCurrentChoice(choice)}
              >
                {choice.label}
              </div>
            ))
          ) : (
            <p className="text-secondary my-2">Ancora nessuna scelta</p>
          )}
        </div>
        <button
          type="button"
          className="btn bg-blue-button text-white w-100"
          onClick={() => setCurrentChoice({ label: '', content: '', id: null })}
        >
          Aggiungi scelta
        </button>
      </div>

      {currentChoice && (
        <div
          className="col-6 d-flex flex-column h-100"
          style={{ borderLeft: '1px black solid' }}
        >
          <label>Etichetta della scelta</label>
          <input
            type="text"
            className="form-control mb-3"
            value={currentChoice.label}
            onChange={(e) =>
              setCurrentChoice({ ...currentChoice, label: e.target.value })
            }
          />

          <label>Testo in chat</label>
          <textarea
            className="form-control"
            style={{ height: '100px' }}
            value={currentChoice.content}
            onChange={(e) =>
              setCurrentChoice({ ...currentChoice, content: e.target.value })
            }
          ></textarea>
          <label className="mt-3">Seleziona nodo</label>
          <Select
            options={nodes_options}
            placeholder="Cerca..."
            isSearchable
            value={nodes_options.find(
              (option) => option.value === currentChoice?.skipToNode,
            )}
            onChange={(option) =>
              setCurrentChoice({ ...currentChoice, skipToNode: option?.value })
            }
          />

          <div className="mt-auto d-flex justify-content-between gap-2">
            <span
              className="bg-transparent text-danger"
              style={{ cursor: 'pointer' }}
              onClick={() => handleRemoveChoice(currentChoice)}
            >
              Rimuovi scelta
            </span>
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setCurrentChoice(null)}
              >
                Annulla
              </button>
              <button
                className="btn bg-blue-button text-white"
                onClick={handleSaveChoice}
              >
                Salva Scelta
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RispostaChiusa;
